<template >
  <Modal v-bind="$attrs" @cancel="$emit('cancel')" @confirm="onConfirm">
    <CreativePreview :groups="creativeGroups">
      <template #checkbox="{ item, index }">
        <el-checkbox v-model="item.isCheck" @change="onCheckStateChange($event, index)"> </el-checkbox>
        <span>&ensp;</span>
      </template>
    </CreativePreview>
  </Modal>
</template>
<script>
import Modal from './modal.vue'
import CreativePreview from '@/views/create/gdt/template/components/creative/components/creative-preview/index.vue'
export default {
  props: {
    creativeList: {
      type: Array,
      default: () => []
    }
  },
  components: { Modal, CreativePreview },
  data() {
    return {
      creativeGroups: this.creativeList
    }
  },

  methods: {
    onCheckStateChange(val, index) {
      this.creativeGroups = this.creativeGroups.map((c, _index) => {
        if (val) {
          return { ...c, isCheck: _index === index }
        }
        return { ...c, isCheck: false }
      })
    },
    onConfirm() {
      const checkedItem = this.creativeGroups.find((c) => c.isCheck)
      if (checkedItem) {
        this.$emit('confirm', checkedItem)
      } else {
        this.$message.error('请选择一个创意组')
      }
    }
  }
}
</script>
